class SizeRecommender {
    constructor() {
        // Check if the primary button to open the modal exists.
        // If not, it's likely a product type where the recommender shouldn't be active.
        this.openBtn = document.getElementById('sizeRecommenderBtn');
        if (!this.openBtn) {
            // console.log('Size Recommender button not found on this page. Skipping initialization.');
            return; // Exit constructor, do not initialize
        }
        this.init();
    }

    init() {
        // Cache DOM elements that are part of the modal structure (these should always exist if the feature is loaded)
        this.overlay = document.getElementById('sizeRecommenderOverlay');
        this.closeBtn = document.getElementById('sizeRecommenderClose');
        this.brandSelect = document.getElementById('brandSelect');
        this.sizeSelect = document.getElementById('sizeSelect');
        this.form = document.getElementById('sizeRecommenderForm');
        this.confirmBtn = document.getElementById('confirmBtn');
        this.resultElement = document.getElementById('sizeResult');
        this.recommendedSizeElement = document.getElementById('recommendedSize');
        this.selectedBrandElement = document.getElementById('selectedBrand');
        this.selectedSizeElement = document.getElementById('selectedSize');

        // Elements that are conditional (related to showing the button or result display)
        this.resultDisplay = document.getElementById('sizeRecommendedDisplay');
        this.displayedSize = document.getElementById('displayedSize');
        this.changeSizeLink = document.getElementById('changeSizeLink');


        // Check if all essential modal structure elements are present
        if (!this.overlay || !this.closeBtn || !this.brandSelect || !this.sizeSelect || !this.form || !this.confirmBtn || !this.resultElement) {
            console.error('One or more essential Size Recommender modal elements are missing from the DOM. Aborting initialization.');
            return;
        }
        
        this.bindEvents();
    }

    bindEvents() {
        // Modal öffnen (this.openBtn is already checked in constructor)
        this.openBtn.addEventListener('click', () => {
            this.openModal();
        });

        // Modal schließen
        this.closeBtn.addEventListener('click', () => {
            this.closeModalAndReplaceButton();
        });

        // "Ändern" link clicked - reopen modal
        // This element is also conditional, so check if it exists
        if (this.changeSizeLink) {
            this.changeSizeLink.addEventListener('click', (e) => {
                e.preventDefault();
                this.showOriginalButton();
                this.openModal();
            });
        }

        // Bei Klick auf Overlay schließen
        this.overlay.addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                this.closeModalAndReplaceButton();
            }
        });

        // Bei Escape-Taste schließen
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.overlay.classList.contains('active')) {
                this.closeModalAndReplaceButton();
            }
        });

        // Größen-Dropdown aktivieren wenn Marke ausgewählt
        this.brandSelect.addEventListener('change', () => {
            this.handleBrandChange();
        });

        // Bestätigen-Button aktivieren wenn beide Auswahlen getroffen
        this.sizeSelect.addEventListener('change', () => {
            this.handleSizeChange();
        });

        // Formular-Eingabe verarbeiten
        this.form.addEventListener('submit', (e) => {
            // console.log('Form submitted!'); // Keep for debugging if needed
            e.preventDefault();
            this.handleSubmit();
        });

        // Alternative: Direct button click handler (useful if submit event is problematic)
        this.confirmBtn.addEventListener('click', (e) => {
            // console.log('Button clicked directly!'); // Keep for debugging if needed
            // Only prevent default if it's not a submit type already handled by form submit
            if (this.confirmBtn.type !== 'submit') {
                 e.preventDefault();
            }
            // Check if the form is valid before submitting (basic check)
            if (this.brandSelect.value && this.sizeSelect.value) {
                this.handleSubmit();
            } else if (this.form.checkValidity && !this.form.checkValidity()) {
                // If browser supports checkValidity and form is invalid, let browser handle it or show custom message
                // For simple case, we can rely on the handleSubmit's own checks
            } else {
                 // console.log('Form not ready for direct button submit via click.');
            }
        });
    }

    openModal() {
        this.overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        this.trackEvent('groessenberater_geoeffnet');
    }

    closeModal() {
        this.overlay.classList.remove('active');
        document.body.style.overflow = '';
        this.resetForm();
    }

    closeModalAndReplaceButton() {
        if (this.resultElement && this.resultElement.classList.contains('show') && this.recommendedSizeElement) {
            const recommendedSize = this.recommendedSizeElement.textContent;
            this.closeModal();
            this.replaceButtonWithResult(recommendedSize);
        } else {
            this.closeModal();
        }
    }

    handleBrandChange() {
        if (this.brandSelect.value) {
            this.sizeSelect.disabled = false;
        } else {
            this.sizeSelect.disabled = true;
            this.sizeSelect.value = ''; // Reset size selection
            this.updateConfirmButton();
        }
         // Always update confirm button state after brand change
        this.updateConfirmButton();
    }

    handleSizeChange() {
        this.updateConfirmButton();
    }

    updateConfirmButton() {
        this.confirmBtn.disabled = !(this.brandSelect.value && this.sizeSelect.value);
    }

    handleSubmit() {
        // console.log('handleSubmit called!');
        if (!this.brandSelect.value || !this.sizeSelect.value) {
            // console.log('Missing selection - Brand:', this.brandSelect.value, 'Size:', this.sizeSelect.value);
            // Consider a more user-friendly notification than alert, or ensure your form uses HTML5 validation
            alert('Bitte wählen Sie sowohl eine Marke als auch eine Größe aus.');
            return;
        }

        const selectedBrand = this.brandSelect.options[this.brandSelect.selectedIndex].text;
        const selectedSize = this.sizeSelect.options[this.sizeSelect.selectedIndex].text;
        const recommendedSize = selectedSize; // Placeholder for actual recommendation logic

        // console.log('Selected brand:', selectedBrand);
        // console.log('Selected size:', selectedSize);
        // console.log('Recommended size:', recommendedSize);

        this.showResult(selectedBrand, selectedSize, recommendedSize);
        this.trackEvent('groessenempfehlung_generiert', {
            marke: selectedBrand,
            benutzer_groesse: selectedSize,
            empfohlene_groesse: recommendedSize
        });
    }

    showResult(brand, userSize, recommendedSize) {
        // console.log('showResult called with:', brand, userSize, recommendedSize);
        if (!this.selectedBrandElement || !this.selectedSizeElement || !this.recommendedSizeElement || !this.resultElement) {
            console.error('Missing result display elements in showResult.');
            return;
        }
        this.selectedBrandElement.textContent = brand;
        this.selectedSizeElement.textContent = userSize;
        this.recommendedSizeElement.textContent = recommendedSize;
        this.resultElement.classList.add('show');
        // console.log('Result should now be visible');
    }

    replaceButtonWithResult(recommendedSize) {
        // this.openBtn is the cached #sizeRecommenderBtn
        // this.resultDisplay is the cached #sizeRecommendedDisplay
        // this.displayedSize is the cached #displayedSize
        if (this.openBtn && this.resultDisplay && this.displayedSize) {
            this.openBtn.style.display = 'none';
            this.displayedSize.textContent = recommendedSize;
            this.resultDisplay.classList.add('show');
            this.trackEvent('groessenempfehlung_button_ersetzt', {
                empfohlene_groesse: recommendedSize
            });
        } else {
             console.warn('Button/Result display elements not found for replacement. This may be normal if the button was not initially rendered.');
        }
    }

    resetForm() {
        this.form.reset();
        this.sizeSelect.disabled = true;
        this.confirmBtn.disabled = true;
        this.resultElement.classList.remove('show');
    }

    showOriginalButton() {
        if (this.openBtn && this.resultDisplay) {
            this.openBtn.style.display = 'inline-flex'; // Or 'block' or original display type
            this.resultDisplay.classList.remove('show');
        }
    }

    trackEvent(eventName, properties = {}) {
        // console.log('Event verfolgen:', eventName, properties);
        // Placeholder for actual analytics integration
    }
}

// Initialisieren wenn DOM geladen ist
document.addEventListener('DOMContentLoaded', () => {
    new SizeRecommender();
});